import { when, set } from 'cerebral/operators'
import { props, state, resolveObject } from 'cerebral/tags'
import createSnackbar from 'modules/App/factories/createSnackbar'
import loadMediaFiles from './loadMediaFiles'
import selectTreeNodes from 'modules/Node/actions/selectTreeNodes'
import deselectAllFiles from 'modules/Media/chains/deselectAllFiles'

export default [
  when(props`query`),
  {
    true: [
      set(state`node.selectedNode.id`, null),
      set(state`node.selectedNode.path`, null),
      ...deselectAllFiles,
      set(state`media.latestSearchCriteria`, props`query`),
      when(state`app.currentView`, view => view === 'startpage'),
      {
        true: [
          set(state`node.showMenuToggle`, true),
          set(state`node.tree.open`, true)
        ],
        false: []
      },
      set(state`media.selectedFiles`, []),
      selectTreeNodes, // since path is not passed it will deselect last node
      loadMediaFiles,
      set(state`app.currentView`, 'media'),
      set(state`app.showSort`, true),
      set(state`startPage.latest`, false),
      createSnackbar(
        resolveObject({
          key: 'bms.media.search.result',
          params: resolveObject({ criteria: props`query`, count: props`total` })
        })
      )
    ],
    false: [createSnackbar({ key: 'bms.media.search.noValue' }, 'error')]
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/searchMedia.js